import { IconProps } from '@repo/ui/components/Icon';
import BrandIcon from '@repo/ui/components/Icon/v2/BrandIcon';
import CoverIcon from '@repo/ui/components/Icon/v2/CoverIcon';
import EducationIcon from '@repo/ui/components/Icon/v2/EducationIcon';
import FireIcon from '@repo/ui/components/Icon/v2/FireIcon';
import MarketingIcon from '@repo/ui/components/Icon/v2/MarketingIcon';
import MugIcon from '@repo/ui/components/Icon/v2/MugIcon';
import PiechartIcon from '@repo/ui/components/Icon/v2/PiechartIcon';
import StarPairIcon from '@repo/ui/components/Icon/v2/StarPairIcon';
import StationeryIcon from '@repo/ui/components/Icon/v2/StationeryIcon';
import ThumbUpIcon from '@repo/ui/components/Icon/v2/ThumbUpIcon';
import TShirtIcon from '@repo/ui/components/Icon/v2/TShirtIcon';

export const USECASE_ICONS: { [key: string]: React.FC<IconProps> } = {
  all: FireIcon,
  marketing: MarketingIcon,
  social: ThumbUpIcon,
  stationery: StationeryIcon,
  apparel: TShirtIcon,
  branding: BrandIcon,
  home: MugIcon,
  covers: CoverIcon,
  merchandise: TShirtIcon,
  'kittl-ai': StarPairIcon,
  education: EducationIcon,
  business: PiechartIcon,
};

export const KITTL_AI_SLUG = 'kittl-ai';
